module.exports = __webpack_public_path__ + "media/images/down-arrow-f58e4fe0e588ce87627beab5a4ccdac9.png";